export default __webpack_public_path__ + "static/media/logo.a94db64c.webp";